import actions from './actions';
const { isPendingStatus, isErrorStatus, isSuccessStatus } = actions;

const setIsPending = (isPending) => {
    return async (dispatch) => {
        dispatch(isPendingStatus(isPending));
    };
};

const setIsError = (isError) => {
    return async (dispatch) => {
        dispatch(isErrorStatus(isError));
    };
};

const setIsSuccess = (isSuccess) => {
    return async (dispatch) => {
        dispatch(isSuccessStatus(isSuccess));
    };
};

export { setIsPending, setIsError, setIsSuccess };
